import { clsx, type ClassValue } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

// Teach tailwind-merge about the project-specific font-size tokens declared
// in tailwind.config.js (text-h1..text-h4, text-icon-sm..text-icon-lg).
// Without this, twMerge falls back to its built-in "text-*" matching, which
// can't tell our custom keys apart from text-color utilities and ends up
// silently dropping a "text-h4" when it sits next to a "text-primary-contrast"
// in the same className.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        { text: ["h1", "h2", "h3", "h4", "icon-sm", "icon-md", "icon-lg"] },
      ],
    },
  },
})

const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs))

export default cn
